document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".maison-product-card").forEach((card) => {
    const variants = card.querySelectorAll(".maison-product-card__variant");
    const addButton = card.querySelector(
      ".maison-product-card__add-to-cart__button"
    );
    if (!addButton) return;

    let selectedVariantId = null;

    variants.forEach((variantEl) => {
      variantEl.addEventListener("click", () => {
        if (variantEl.classList.contains("is-disabled")) return;

        variants.forEach((v) => v.classList.remove("active"));
        variantEl.classList.add("active");
        selectedVariantId = variantEl.dataset.variantId;
      });
    });

    addButton.addEventListener("click", async () => {
      if (
        addButton.classList.contains("is-disabled") ||
        addButton.classList.contains("loading")
      )
        return;

      addButton.classList.add("loading");

      let variantId = selectedVariantId;
      if (!variantId) {
        const firstAvailable = card.querySelector(
          ".maison-product-card__variant:not(.is-disabled)"
        );
        if (firstAvailable) {
          variantId = firstAvailable.dataset.variantId;
        } else {
          addButton.classList.remove("loading");
          return;
        }
      }

      try {
        // Shopify AJAX API
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
          }),
        });

        if (!res.ok) throw new Error("Add to cart failed");
        // fetch("/cart.json")
        //   .then((r) => r.json())
        //   .then((data) => {
        //     const countBubble = document.querySelector(".cart-count-bubble span");
        //     if (countBubble) countBubble.textContent = data.item_count;
        //   });
        document.dispatchEvent(new CustomEvent('maison:cart-drawer-reload'));
        variants.forEach((v) => v.classList.remove("active"));
        selectedVariantId = null;
      } catch (err) {
        console.error(err);
      } finally {
        addButton.classList.remove("loading");
      }
    });
  });
});
